import Component from "./Switch";
import Loader from "./components/Loader/SwitchLoader";

interface ISwitchExtensions {
    Loader: typeof Loader;
}

export const Switch: typeof Component & ISwitchExtensions = Object.assign(
    Component,
    {
        Loader,
    },
);

export type { SwitchProps } from "./types";
